import React from "react";
import { Typography } from "@mui/material";

import { brand } from "../themes/theme";

/**
 * Nota de cierre de panel (metodologia/aclaracion), con el mismo tratamiento
 * visual que ya usa clinica (BehavioralView: separador superior + gris mas
 * apagado) en vez de un parrafo plano pegado justo debajo del grafico/tabla.
 */
function PanelFootnote({ children, sx }) {
    return (
        <Typography
            sx={{
                fontSize: 10.5,
                color: brand.gray500,
                lineHeight: 1.5,
                mt: 1.25,
                pt: 1.25,
                borderTop: "1px solid",
                borderColor: brand.gray100,
                ...sx,
            }}
        >
            {children}
        </Typography>
    );
}

export default PanelFootnote;
